/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_TitleInputs */

const en_fc_vs_title = /** @type {(inputs: Fc_Vs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft vs Premiere Pro`)
};

/**
* | output |
* | --- |
* | "FilmCraft vs Premiere Pro" |
*
* @param {Fc_Vs_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_title = /** @type {((inputs?: Fc_Vs_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_title(inputs)
});
export { fc_vs_title as "fc.vs.title" }